module.exports = __webpack_public_path__ + "img/tabelleloeschen.291fb30.svg";